import settings from '@/api/apiSferest/services/settings'

export const getSettingsErp = ({commit}) => {
  return new Promise((resolve, reject) => {
    settings.erp.get()
    .then((res) => {
      commit('SET_SELECTED', res.data.grant)
      resolve()
    })
  })
}

export const postSettingsErp = ({commit, state}) => {
  return new Promise((resolve, reject) => {
    let body = {
      grant: state.selected,
      password: state.password
    }
    settings.erp.create(body).then((res) => {
      if (res.data.file) {
        var link = document.createElement('a')
        link.setAttribute('href', 'data:text/plain;base64,' + btoa(res.data.file))
        link.setAttribute('download', res.data.name)
        link.click()
      }
    })
  })
}
